import { BeneMobile } from '../../../models/bene-mobile/bene-mobile';
import { IstanzaAssegnazione } from '../../../models/immobili/istanza-assegnazione';
import { IstanzaVendita } from '../../../models/immobili/istanza-vendita';
import { Ubicazione } from '../../../models/immobili/ubicazione';

export class BeniMobiliAdapter {

  static createBeniMobiliRequest(beneMobile: BeneMobile): BeneMobile {
    let clonedBeneMobile: BeneMobile = new BeneMobile();
    if (beneMobile && beneMobile.id) {
      clonedBeneMobile.id = beneMobile.id;
    }
    clonedBeneMobile.tipoBeneMobile = beneMobile.tipoBeneMobile ? JSON.parse(JSON.stringify(beneMobile.tipoBeneMobile)) : null;
    clonedBeneMobile.descrizione = beneMobile.descrizione;
    clonedBeneMobile.ubicazione = new Ubicazione();
    if (beneMobile.ubicazione) {
      if (beneMobile.ubicazione.id) {
        clonedBeneMobile.ubicazione.id = beneMobile.ubicazione.id;
      }
      clonedBeneMobile.ubicazione.via = beneMobile.ubicazione.via;
      clonedBeneMobile.ubicazione.civico = beneMobile.ubicazione.civico;
      clonedBeneMobile.ubicazione.cap = beneMobile.ubicazione.cap;
      clonedBeneMobile.ubicazione.nazione = beneMobile.ubicazione.nazione;
      clonedBeneMobile.ubicazione.provincia = beneMobile.ubicazione.provincia ? JSON.parse(JSON.stringify(beneMobile.ubicazione.provincia)) : null;
      clonedBeneMobile.ubicazione.localita = beneMobile.ubicazione.localita ? JSON.parse(JSON.stringify(beneMobile.ubicazione.localita)) : null;
    } else {
      clonedBeneMobile.ubicazione.provincia = null;
      clonedBeneMobile.ubicazione.localita = null;
    }

    clonedBeneMobile.valore = beneMobile.valore;
    if (clonedBeneMobile.valore) {
      clonedBeneMobile.valore = clonedBeneMobile.valore.toString().trim().replace('.', ',');
    }

    clonedBeneMobile.valoreIpoteca = beneMobile.valoreIpoteca;
    if (clonedBeneMobile.valoreIpoteca) {
      clonedBeneMobile.valoreIpoteca = clonedBeneMobile.valoreIpoteca.toString().trim().replace('.', ',');
    }

    clonedBeneMobile.sommaBloccata = beneMobile.sommaBloccata;
    if (clonedBeneMobile.sommaBloccata) {
      clonedBeneMobile.sommaBloccata = clonedBeneMobile.sommaBloccata.toString().trim().replace('.', ',');
    }

    clonedBeneMobile.dataBloccoSomma = beneMobile.dataBloccoSomma;

    clonedBeneMobile.sommaSvincolata = beneMobile.sommaSvincolata;
    if (clonedBeneMobile.sommaSvincolata) {
      clonedBeneMobile.sommaSvincolata = clonedBeneMobile.sommaSvincolata.toString().trim().replace('.', ',');
    }

    clonedBeneMobile.dataSvincoloSomma = beneMobile.dataSvincoloSomma;
    if (beneMobile.ipoteca) {
      clonedBeneMobile.ipoteca = beneMobile.ipoteca;
    } else {
      clonedBeneMobile.ipoteca = false;
    }
    clonedBeneMobile.quantita = beneMobile.quantita;
    clonedBeneMobile.riferimentoInventario = beneMobile.riferimentoInventario;
    clonedBeneMobile.dataInventario = beneMobile.dataInventario;
    clonedBeneMobile.note = beneMobile.note;
    clonedBeneMobile.unitaMisura = beneMobile.unitaMisura;
    clonedBeneMobile.documenti = beneMobile.documenti;
    clonedBeneMobile.quota = beneMobile.quota;
    clonedBeneMobile.tipoDirittoReale = beneMobile.tipoDirittoReale ? JSON.parse(JSON.stringify(beneMobile.tipoDirittoReale)) : null;
    clonedBeneMobile.istanzaVendita = new IstanzaVendita();
    if (beneMobile.istanzaVendita) {
      if (beneMobile.istanzaVendita.id) {
        clonedBeneMobile.istanzaVendita.id = beneMobile.istanzaVendita.id;
      }
      clonedBeneMobile.istanzaVendita.dataIstanza = beneMobile.istanzaVendita.dataIstanza;
      clonedBeneMobile.istanzaVendita.acquirente = beneMobile.istanzaVendita.acquirente;
      clonedBeneMobile.istanzaVendita.ricavato = beneMobile.istanzaVendita.ricavato;
      if (clonedBeneMobile.istanzaVendita.ricavato) {
        clonedBeneMobile.istanzaVendita.ricavato = clonedBeneMobile.istanzaVendita.ricavato.toString().trim().replace('.', ',');
      }
      if (beneMobile.istanzaVendita.vendita) {
        clonedBeneMobile.istanzaVendita.vendita = beneMobile.istanzaVendita.vendita;
      } else {
        clonedBeneMobile.istanzaVendita.vendita = false;
      }

    } else {
      clonedBeneMobile.istanzaVendita.vendita = false;
    }

    clonedBeneMobile.istanzaAssegnazione = new IstanzaAssegnazione();
    if (beneMobile.istanzaAssegnazione) {
      if (beneMobile.istanzaAssegnazione.id) {
        clonedBeneMobile.istanzaAssegnazione.id = beneMobile.istanzaAssegnazione.id;
      }
      clonedBeneMobile.istanzaAssegnazione.dataIstanza =  beneMobile.istanzaAssegnazione.dataIstanza;
      if (beneMobile.istanzaAssegnazione.assegnato) {
        clonedBeneMobile.istanzaAssegnazione.assegnato = beneMobile.istanzaAssegnazione.assegnato;
      } else {
        clonedBeneMobile.istanzaAssegnazione.assegnato = false;
      }
    } else {
      clonedBeneMobile.istanzaAssegnazione.assegnato = false;
    }

    clonedBeneMobile.pignorato = beneMobile.pignorato;
    clonedBeneMobile.dataNotifica = beneMobile.dataNotifica ? beneMobile.dataNotifica : null;
    clonedBeneMobile.dataRichiestaNotifica = beneMobile.dataRichiestaNotifica ? beneMobile.dataRichiestaNotifica : null;
    clonedBeneMobile.terzo = beneMobile.terzo ? beneMobile.terzo : null;

    return clonedBeneMobile;
  }



  static manageRequestForServer(beneMobile: BeneMobile): BeneMobile {
    let clonedBeneMobile: BeneMobile = new BeneMobile();
    if (beneMobile.id) {
      clonedBeneMobile.id = beneMobile.id;
    }
    clonedBeneMobile.tipoBeneMobile = beneMobile.tipoBeneMobile;
    clonedBeneMobile.descrizione = beneMobile.descrizione;

    if (!beneMobile.ubicazione.via && !beneMobile.ubicazione.civico && !beneMobile.ubicazione.cap && !beneMobile.ubicazione.localita && !beneMobile.ubicazione.provincia && !beneMobile.ubicazione.nazione) {
      clonedBeneMobile.ubicazione = null;
    } else {
      clonedBeneMobile.ubicazione = beneMobile.ubicazione;
    }

    if (beneMobile.valore) {
      clonedBeneMobile.valore = beneMobile.valore.toString().trim().replace(',', '.');
    }

    if (beneMobile.valoreIpoteca) {
      clonedBeneMobile.valoreIpoteca = beneMobile.valoreIpoteca.toString().trim().replace(',', '.');
    }

    if (beneMobile.sommaBloccata) {
      clonedBeneMobile.sommaBloccata = beneMobile.sommaBloccata.toString().trim().replace(',', '.');
    }

    clonedBeneMobile.dataBloccoSomma = beneMobile.dataBloccoSomma;

    if (beneMobile.sommaSvincolata) {
      clonedBeneMobile.sommaSvincolata = beneMobile.sommaSvincolata.toString().trim().replace(',', '.');
    }

    clonedBeneMobile.dataSvincoloSomma = beneMobile.dataSvincoloSomma;
    clonedBeneMobile.ipoteca = beneMobile.ipoteca;
    clonedBeneMobile.quantita = beneMobile.quantita;
    clonedBeneMobile.riferimentoInventario = beneMobile.riferimentoInventario;
    clonedBeneMobile.dataInventario = beneMobile.dataInventario;
    clonedBeneMobile.note = beneMobile.note;
    clonedBeneMobile.unitaMisura = beneMobile.unitaMisura;
    clonedBeneMobile.documenti = beneMobile.documenti;
    clonedBeneMobile.quota = beneMobile.quota;
    clonedBeneMobile.tipoDirittoReale = beneMobile.tipoDirittoReale ? JSON.parse(JSON.stringify(beneMobile.tipoDirittoReale)) : null;

    if (beneMobile.istanzaVendita) {
      clonedBeneMobile.istanzaVendita = new IstanzaVendita();
      if (beneMobile.istanzaVendita.id) {
        clonedBeneMobile.istanzaVendita.id = beneMobile.istanzaVendita.id;
      }

      clonedBeneMobile.istanzaVendita.acquirente = beneMobile.istanzaVendita.acquirente;
      if (beneMobile.istanzaVendita.dataIstanza) {
        clonedBeneMobile.istanzaVendita.dataIstanza = beneMobile.istanzaVendita.dataIstanza;
      }

      if (beneMobile.istanzaVendita.vendita) {
        clonedBeneMobile.istanzaVendita.vendita = beneMobile.istanzaVendita.vendita;
      } else {
        clonedBeneMobile.istanzaVendita.vendita = false;
      }

      if (beneMobile.istanzaVendita.ricavato) {
        clonedBeneMobile.istanzaVendita.ricavato = beneMobile.istanzaVendita.ricavato.toString().replace(',', '.');
      }
    }

    clonedBeneMobile.istanzaAssegnazione = beneMobile.istanzaAssegnazione;
    clonedBeneMobile.pignorato = beneMobile.pignorato;
    clonedBeneMobile.dataNotifica = beneMobile.dataNotifica ? beneMobile.dataNotifica : null;
    clonedBeneMobile.dataRichiestaNotifica = beneMobile.dataRichiestaNotifica ? beneMobile.dataRichiestaNotifica : null;
    clonedBeneMobile.terzo = beneMobile.terzo ? beneMobile.terzo : null;
    return clonedBeneMobile;
  }
}
